(function () {
  if (window.amoreCartReady) return;
  window.amoreCartReady = true;

  // CART-07 (12.09.2026): владелец явно запретил удаление позиции через «−» на
  // границе количества 1 — «−» на 1 должен быть неактивен, единственный путь
  // прочь из строки — кнопка Remove. Перехват клика, который CART-01 (09.09.2026)
  // держал вторым путём к удалению (сводил «−» на 1 к cartDrawerItems.
  // updateQuantity(...,0,...)), снят целиком. Dawn's native quantity-input уже
  // добавляет .disabled на эту кнопку по достижении minimum (assets/global.js
  // validateQtyRules) и её stepDown() не уходит ниже min — без перехвата клик
  // по «−» на 1 просто ничего не делает.

  /* Высота баннера согласия. Он стоит `position: fixed` внизу и ложится
     ПОВЕРХ панели корзины: нижнюю строку футера не выталкивает, а накрывает.
     Поле читает amore-cart.css и держит на эту высоту запас снизу.

     Условие намеренно строгое — баннер должен быть НА ЭКРАНЕ: отрисован,
     не скрыт, прижат к нижнему краю. Он показывается не всем (Европа и
     Британия), и постоянный запас в сотню пикселей у остальных был бы
     дырой внизу панели. Нет баннера — поле 0, остаётся 12 px из CSS. */
  const measureConsentBanner = () => {
    const banner = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
    let height = 0;
    if (banner) {
      const style = window.getComputedStyle(banner);
      const rect = banner.getBoundingClientRect();
      const onScreen =
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        style.position === 'fixed' &&
        rect.height > 0 &&
        rect.bottom > window.innerHeight - 2;
      if (onScreen) height = Math.round(rect.height);
    }
    document.documentElement.style.setProperty('--amore-consent-height', height + 'px');
  };

  measureConsentBanner();
  // Баннер приходит и уходит поддеревом прямо в body — childList без subtree
  // ловит и появление, и снятие, и стоит на порядок дешевле полного обхода.
  new MutationObserver(measureConsentBanner).observe(document.body, { childList: true });
  window.addEventListener('resize', measureConsentBanner);
  document.addEventListener('DOMContentLoaded', measureConsentBanner, { once: true });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-amore-cart-whatsapp]');
    if (!button) return;
    event.preventDefault();
    button.disabled = true;
    try {
      const response = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Cart request failed with ${response.status}`);
      const cart = await response.json();
      const message = cart.items.map((item) => `${item.product_title}, ${item.quantity}`).join('\n');
      window.location.href = `https://wa.me/6282146308670?text=${encodeURIComponent(message)}`;
    } catch (error) {
      const region = document.querySelector('[data-amore-cart-support-status]');
      if (region) region.textContent = 'We could not open WhatsApp. Please try again.';
      console.error(error);
    } finally {
      button.disabled = false;
    }
  });

  /* CART-08 (12.09.2026): выбор размера прямо в строке панели ("как у
     Toteme") — меняет вариант позиции без ухода на карточку товара.

     Ajax Cart API не умеет менять вариант существующей строки напрямую
     (`/cart/change.js` меняет только `quantity` у уже существующей `line`).
     Последовательность — та же, что и везде в вебе для этого случая:
       1. Добавить НОВЫЙ вариант тем же количеством и свойствами строки
          (если этот вариант уже лежит в корзине отдельной строкой — Shopify
          сам сольёт его туда по variant_id+properties, дубля не будет: это
          собственное поведение Cart API, не наша логика).
       2. Только при успехе шага 1 обнулить СТАРУЮ строку через
          `/cart/change.js` — если шаг 1 упадёт (например, размер кончился
          между открытием панели и кликом), старая строка остаётся нетронутой.
       3. Перерисовать панель ТЕМ ЖЕ приёмом, что Dawn использует для своих
          секций (CartDrawerItems.getSectionsToRender в cart-drawer.js,
          файл вне зоны этого наряда — здесь просто читаются те же секции
          `cart-drawer`/`cart-icon-bubble` через `sections` в теле запроса).
       4. Опубликовать `PUB_SUB_EVENTS.cartUpdate` — тот же пуб/саб, на
          который уже подписан валютный слой (currency-duties-2026-07.js,
          `restartNovaOnCartUpdate`, ЕГО СЛОВАМИ: «Primary trigger is Dawn's
          own cartUpdate pub/sub event») — без этого шага сумма строки и
          Subtotal остались бы пересчитаны в исходной, а не выбранной
          покупателем валюте до следующего события корзины. */
  // Capture phase, not bubble: `<select data-amore-size-select>` lives inside
  // `<cart-drawer-items>`, and Dawn's own `CartItems` binds a bubble-phase
  // 'change' listener directly on that element (assets/cart.js, expects a
  // quantity `<input>` with `dataset.index`/`dataset.quantityVariantId`).
  // A bubble-phase listener here would fire AFTER that ancestor listener —
  // too late to stop it — and Dawn would read our select's variant-id value
  // as a bogus quantity and fire its own malformed `/cart/change.js`
  // alongside ours. Capture fires top-down, before Dawn's listener ever
  // sees the event, so `stopPropagation` here keeps it from running at all.
  document.addEventListener(
    'change',
    (event) => {
      const select = event.target.closest('[data-amore-size-select]');
      if (!select) return;
      event.stopPropagation();
      handleAmoreSizeChange(select);
    },
    true
  );

  // CART-09 (14.09.2026): наряд §Поведение «клик по слову "Size M" или по
  // шеврону открывает список размеров» — до этого наряда только сам
  // `<select>` реагировал на клик (нативно), а он в разметке узкий (24×21,
  // ширина по значению варианта, не по слову целиком) — «Size» (`dt`) и
  // шеврон (свой `<svg>`, amore-cart.css) лежат РЯДОМ, не внутри контрола,
  // и по ним ничего не происходило (симптом владельца).
  // Замена `<select>` на собственное выпадающее меню наряд прямо запрещает
  // без решения владельца (см. СТОП-УСЛОВИЕ) — контрол остаётся тем же
  // нативным `<select>`, здесь только расширяется его ТОЧКА ВХОДА:
  // `HTMLSelectElement.prototype.showPicker()` (Chrome 121+) программно
  // открывает нативный список у уже сфокусированного select, не подменяя
  // его. Прямой клик по самому select's узкому нативному полю по-прежнему
  // открывает его сам браузер — `closest('.amore-size-select')` здесь
  // отсекает именно этот случай, чтобы не вызывать showPicker() поверх уже
  // открывающегося браузером списка (двойной вызов на части браузеров
  // закрывает список вместо открытия).
  document.addEventListener('click', (event) => {
    const wordBox = event.target.closest('[data-amore-size-word]');
    if (!wordBox) return;
    if (event.target.closest('.amore-size-select')) return;
    const select = wordBox.querySelector('.amore-size-select');
    if (!select || select.disabled) return;
    event.preventDefault();
    // Тот же атрибут и тот же приём, что `pointerdown` ниже ставит для
    // прямого клика по select — клик по слову/шеврону тоже открывает
    // список указателем, и паперное кольцо фокуса на этот цикл гасится
    // ровно как при клике по самому контролу (правило CART-08B, amore-
    // cart.css, не меняется).
    select.setAttribute('data-amore-pointer-focus', '');
    select.focus({ preventScroll: true });
    if (typeof select.showPicker === 'function') {
      try {
        select.showPicker();
      } catch (error) {
        // Браузеры без транзиентной активации (редкий edge case,
        // например синтетический клик) молча игнорируют showPicker() —
        // select остаётся сфокусированным, доступен с клавиатуры.
      }
    }
  });

  // CART-08, возврат (приёмка владельца 12.09): «после выбора мышью рамка
  // остаётся». В этом движке `<select>` матчит `:focus-visible` всегда,
  // даже после клика мышью (замер живьём: сразу true, ни одной клавиши не
  // нажато) — CSS-модальность здесь для `<select>` не работает так, как
  // для обычного текстового поля или кнопки, различать вручную.
  // `pointerdown` ставит метку ДО того, как элемент получит фокус — CSS
  // (amore-cart.css, `[data-amore-pointer-focus]`) гасит по ней и свою
  // рамку, и общий паперный ring зоны «рама», ровно на этот цикл фокуса.
  // `focusout` снимает метку сразу, как фокус уходит — следующий заход в
  // этот же select клавиатурой (без предшествующего pointerdown) её уже
  // не находит, и оба кольца показываются как обычно.
  document.addEventListener(
    'pointerdown',
    (event) => {
      const select = event.target.closest('.amore-size-select');
      if (select) select.setAttribute('data-amore-pointer-focus', '');
    },
    true
  );

  document.addEventListener(
    'focusout',
    (event) => {
      const select = event.target.closest && event.target.closest('.amore-size-select');
      if (select) select.removeAttribute('data-amore-pointer-focus');
    },
    true
  );

  async function handleAmoreSizeChange(select) {
    // Re-entrancy guard: a native `<select>` can fire a real 'change' per
    // arrow-key step even while still focused (not just on Enter/blur), so
    // two calls can overlap for the same control before the first one's
    // add+remove round trip finishes and replaces this row's markup. Without
    // this, the second call would still read the ORIGINAL (pre-swap)
    // `data-line-key`/`data-current-variant-id`, add its own variant on top
    // of the first, and remove nothing that matches — a duplicate line.
    if (select.dataset.amoreSizeChanging) return;
    select.dataset.amoreSizeChanging = 'true';

    const newVariantId = select.value;
    const previousVariantId = select.dataset.currentVariantId;
    if (!newVariantId || newVariantId === previousVariantId) {
      delete select.dataset.amoreSizeChanging;
      return;
    }

    const quantity = parseInt(select.dataset.quantity, 10) || 1;
    let properties = {};
    try {
      const parsedProperties = JSON.parse(select.dataset.properties || '{}');
      // Liquid's `json` filter renders an empty `item.properties` hash as `[]`,
      // not `{}` — /cart/add.js rejects an array with "expected Array to be a
      // Hash: properties", so fall back to {} whenever it didn't parse to a
      // plain object.
      if (parsedProperties && typeof parsedProperties === 'object' && !Array.isArray(parsedProperties)) {
        properties = parsedProperties;
      }
    } catch (error) {
      properties = {};
    }
    Object.keys(properties).forEach((key) => {
      if (key.charAt(0) === '_' || properties[key] === '') delete properties[key];
    });

    const row = select.closest('.cart-item');
    const overlay = row ? row.querySelector('.loading-overlay') : null;
    const lineKey = select.dataset.lineKey;

    select.disabled = true;
    if (overlay) overlay.classList.remove('hidden');

    try {
      const addResponse = await fetch(`${window.routes.cart_add_url}.js`, {
        ...fetchConfig(),
        body: JSON.stringify({
          items: [{ id: newVariantId, quantity: quantity, properties: properties }],
        }),
      });
      const addResult = await addResponse.json();
      if (!addResponse.ok) {
        throw new Error((addResult && addResult.description) || 'Could not add the selected size.');
      }

      // `id` (the line-item key captured before the add above), not a
      // positional `line` number: adding the new variant can re-sort the
      // cart's own line order (observed live — the new variant did not
      // simply append), which would silently point a numeric line index at
      // the wrong row and remove the size the shopper just chose instead of
      // the one they're replacing. The key is stable across that reorder.
      const changeResponse = await fetch(window.routes.cart_change_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const changeResult = await changeResponse.json();
      if (!changeResponse.ok || changeResult.errors) {
        throw new Error('Could not remove the previous size.');
      }

      applyAmoreCartDrawerSections(changeResult.sections);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: changeResult, variantId: newVariantId });
      }
    } catch (error) {
      console.error(error);
      await resyncAmoreCartDrawer();
    }
  }

  function applyAmoreCartDrawerSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const sourceInner = html.querySelector('.drawer__inner');
      const targetInner = document.querySelector('#CartDrawer .drawer__inner');
      if (sourceInner && targetInner) targetInner.innerHTML = sourceInner.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const sourceBubble = html.querySelector('.shopify-section');
      const targetBubble = document.getElementById('cart-icon-bubble');
      if (sourceBubble && targetBubble) targetBubble.innerHTML = sourceBubble.innerHTML;
    }
  }

  // Best-effort recovery if the add succeeded but the follow-up removal of
  // the old line failed: re-fetch the drawer as it actually is server-side
  // rather than leave the UI showing a stale, now-incorrect state.
  async function resyncAmoreCartDrawer() {
    try {
      const response = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const sourceInner = html.querySelector('.drawer__inner');
      const targetInner = document.querySelector('#CartDrawer .drawer__inner');
      if (sourceInner && targetInner) targetInner.innerHTML = sourceInner.innerHTML;
    } catch (error) {
      console.error(error);
    }
  }

  /* ============ CART-09 (14.09.2026): ШИРИНА СЧЁТЧИКА = ШИРИНА СЛОВА =======
     Наряд §Геометрия: «ширина счётчика числом не задаётся: у "Size M" она
     одна, у "Size XS" другая. Правило — строго по слову этой позиции.»
     CSS (amore-cart.css, `.cart-drawer .quantity { width: var(--amore-qty-
     width, auto) }`) ждёт число с JS — здесь оно и меряется, по факту
     отрисованного `[data-amore-size-word]` (dt+dd «Size M», без шеврона:
     шеврон вынесен в `position:absolute`, в ширину этого узла не входит,
     amore-cart.css).

     Пересчёт не разовый: слово меняется при выборе другого размера
     (`handleAmoreSizeChange` выше подменяет всю разметку строки через
     `applyAmoreCartDrawerSections`/`resyncAmoreCartDrawer`), а количество
     позиций и их содержимое — при добавлении товара и при родном
     степпере Dawn (`cart.js`, вне зоны этого наряда, тоже переписывает
     `.drawer__inner` целиком). Слушать оба пути по отдельности значило бы
     дублировать знание о чужом коде; `MutationObserver` на контейнере
     позиций ловит любую такую замену разметки одним местом, независимо
     от того, чей код её вызвал.

     Та же функция заодно ставит `--amore-frame-top` (amore-cart.css,
     `.cart-item__media`) — центрирование кадра «от строки», а не от
     самого себя. Причина завести это здесь, а не чистым CSS: замер
     живьём (Chrome) показал, что у абсолютно спозиционированного
     grid-item внутри `align-content: center` (`.cart-item`) СТАТИЧНАЯ
     позиция сама съезжает вниз вслед за выровненной группой текстовых
     рядов — `top: 0` перестаёт быть верхним краем строки, будучи вместо
     этого верхним краем уже сдвинутого центрированием текста (замер:
     ~12px на этом макете; с `align-content: start` тот же `top: 0` идёт
     ровно куда надо). `top: 50%` + `translateY(-50%)` (центрирование
     кадра «от себя») пробовали отдельно — та же обманка: проценты `top`
     Chrome тоже резолвит не от padding-box строки, сдвиг выходит другим
     и ещё дальше от истинного верха. `row.getBoundingClientRect()`
     этого искажения не несёт (замер целого элемента всегда верный,
     квирк — только в статичной позиции ЕГО АБСОЛЮТНОГО ПОТОМКА) —
     отсюда и решение мерить строку целиком и печатать уже готовый
     отступ переменной, в обход обеих обманчивых точек отсчёта CSS. */
  function syncAmoreCartSizeCounters() {
    document.querySelectorAll('.cart-drawer .cart-item').forEach((row) => {
      const word = row.querySelector('[data-amore-size-word]');
      const qty = row.querySelector('.cart-item__quantity .quantity');
      if (word && qty) {
        const width = Math.round(word.getBoundingClientRect().width);
        if (width > 0) qty.style.setProperty('--amore-qty-width', width + 'px');
      }

      const media = row.querySelector('.cart-item__media');
      if (media) {
        // Квирк не даёт мерить нужный отступ напрямую (см. комментарий
        // выше «та же функция заодно ставит...») — вместо этого сперва
        // меряется, НАСКОЛЬКО ошибается сам браузер при переменной 0
        // (в кадре нет собственной высоты помимо auto-ratio, поэтому
        // сброс переменной безопасен на каждом цикле), затем поверх
        // этой ошибки пишется поправка, а не абсолютное число.
        media.style.setProperty('--amore-frame-top', '0px');
        const rowRect = row.getBoundingClientRect();
        const frameRect = media.getBoundingClientRect();
        // Кадр 96 шириной при aspect-ratio 3/4 — всегда 128 высотой,
        // независимо от фактической высоты строки (симметрично сжимать
        // кадр наряд не просит).
        const frameHeight = 128;
        const desiredOffset = (rowRect.height - frameHeight) / 2;
        const currentOffset = frameRect.top - rowRect.top;
        const correction = Math.round(desiredOffset - currentOffset);
        media.style.setProperty('--amore-frame-top', correction + 'px');
      }
    });
  }

  // `setTimeout`, не `requestAnimationFrame`: замер живьём показал, что
  // rAF в фоновой/невидимой вкладке может не выстрелить вовсе, пока
  // вкладка не станет активной — первый автозапуск синхронизации на
  // загрузке страницы (когда панель ещё не видна) тогда не происходит
  // ни разу, обе переменные остаются пустыми. `setTimeout` выполняется
  // независимо от видимости вкладки (с той же гарантией, что и остальной
  // JS в фоновой вкладке).
  let amoreCartSizeCounterTimer = null;
  function scheduleAmoreCartSizeCounters() {
    if (amoreCartSizeCounterTimer) return;
    amoreCartSizeCounterTimer = setTimeout(() => {
      amoreCartSizeCounterTimer = null;
      syncAmoreCartSizeCounters();
    }, 0);
  }

  // Замер живьём (Chrome, 1470×956): `document.getElementById('CartDrawer-
  // CartItems')` в момент выполнения этого скрипта — `null`. `amore-cart.js`
  // подключён раньше разметки панели (cart-drawer.liquid рендерится позже
  // по документу), поэтому узел ещё не существует — обсервер на него молча
  // не ставился, и синхронизация не запускалась вообще ни разу. Тот же
  // симптом мог сорвать и первый запуск на `#CartDrawer-CartItems`, если бы
  // узел появился позже (шторка, отрисованная asynchronously). Наблюдаем
  // `document.body` — он есть уже в момент выполнения (тот же приём, что
  // `measureConsentBanner` выше в этом файле) — и не требует, чтобы узел
  // панели существовал заранее.
  new MutationObserver(scheduleAmoreCartSizeCounters).observe(document.body, {
    childList: true,
    subtree: true,
  });
  window.addEventListener('resize', scheduleAmoreCartSizeCounters);
  document.addEventListener('DOMContentLoaded', scheduleAmoreCartSizeCounters, { once: true });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleAmoreCartSizeCounters);
  }
  scheduleAmoreCartSizeCounters();
})();
